import { axiosFetch } from "../../utils/AxiosFetch";
import { lookupsConstant } from "../constants";
import { SnackbarActions } from './snackbar.actions';

export const loadReportingManagers = (req) => (dispatch) => {
  axiosFetch({
    method: "post",
    url: `/lookup/reportingmanagers`,
    requestConfig: req
  })

    .then(res => {
      if (res.status === 200) {
        dispatch(loadReportingManagers_Succeed(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    },
      error => {
        if (error.response.status === 401) {
          window.location.href = "/"
        }
        dispatch(loadReportingManagers_Failed(error));
      }
    )
  // .catch((err) => {
  //   dispatch(loadReportingManagers_Failed(err));
  // });


  function loadReportingManagers_Succeed(data) {

    return {
      type: lookupsConstant.GET_MANAGERS_LOOKUPS_SUCCESS,
      payload: data
    }
  }

  function loadReportingManagers_Failed(err) {

    return {
      type: lookupsConstant.GET_MANAGERS_LOOKUPS_FAILURE,
      payload: err
    }
  }


}


export const loadStatus = () => (dispatch) => {

  axiosFetch({
    method: "get",
    url: "/Lookup/okrstatus"
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadStatus_Succeed(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadStatus_Failed(err)));


  function loadStatus_Succeed(data) {
    return {
      type: lookupsConstant.GET_STATUS_LOOKUP_SUCCESS,
      payload: data
    }
  }

  function loadStatus_Failed(err) {
    return {
      type: lookupsConstant.GET_STATUS_LOOKUP_FAILURE,
      payload: err
    }
  }
}

export const loadUsers = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: "/Lookup/users"
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadUsers_Succeed(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = '/';
      }
    })

    .catch(err => dispatch(loadUsers_Failed(err)));



  function loadUsers_Succeed(data) {
    return {
      type: lookupsConstant.GET_USERS_LOOKUP_DATA_SUCCESS,
      payload: data
    }
  }

  function loadUsers_Failed(err) {
    return {
      type: lookupsConstant.GET_USERS_LOOKUP_DATA_FAILURE,
      payload: err
    }
  }
}

export const loadCommentsType = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: "/Lookup/commenttypes"
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadCommentTypes_Succeed(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadCommentsTypes_Failed(err)))

  function loadCommentTypes_Succeed(data) {
    return {
      type: lookupsConstant.COMMNETS_TYPES_LOOKUP_DATA_SUCCESS,
      payload: data
    }
  }

  function loadCommentsTypes_Failed(err) {
    return {
      type: lookupsConstant.COMMNETS_TYPES_LOOKUP_DATA_FAILURE,
      payload: err
    }
  }
}

export const loadDepartments = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: "/Lookup/departments"
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadDepartment_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadDepartment_failure(err)))

  function loadDepartment_success(data) {
    return {
      type: lookupsConstant.GET_DEPARTMENT_LOOKUP_SUCCESS,
      payload: data
    }
  }

  function loadDepartment_failure(err) {
    return {
      type: lookupsConstant.GET_DEPARTMENT_LOOKUP_FAILURE,
      payload: err
    }
  }
}

export const loadTeams = (id) => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/department/teams/${id}`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadTeam_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadTeam_failure(err)))

  function loadTeam_success(data) {
    return {
      type: lookupsConstant.GET_TEAM_LOOKUP_SUCCESS,
      payload: data
    }
  }

  function loadTeam_failure(err) {
    return {
      type: lookupsConstant.GET_TEAM_LOOKUP_FAILURE,
      payload: err
    }
  }
}


export const loadLocation = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/locations`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadLocation_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadLocation_failure(err)))

  function loadLocation_success(data) {
    return {
      type: lookupsConstant.GET_LOCATION_LOOKUP_SUCCESS,
      payload: data
    }
  }

  function loadLocation_failure(err) {
    return {
      type: lookupsConstant.GET_LOCATION_LOOKUP_FAILURE,
      payload: err
    }
  }
}

export const loadJobTitle = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/jobtitles`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadJobTitle_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadJobTitle_failure(err)))

  function loadJobTitle_success(data) {
    return {
      type: lookupsConstant.GET_JOBTITLE_LOOKUP_SUCCESS,
      payload: data
    }
  }

  function loadJobTitle_failure(err) {
    return {
      type: lookupsConstant.GET_JOBTITLE_LOOKUP_FAILURE,
      payload: err
    }
  }
}

export const loadEmployeeType = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/employeetypes`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadEmpType_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadEmpType_failure(err)))

  function loadEmpType_success(data) {
    return {
      type: lookupsConstant.GET_EMPLOYEETYPE_SUCCESS,
      payload: data
    }
  }

  function loadEmpType_failure(err) {
    return {
      type: lookupsConstant.GET_EMPLOYEETYPE_FAILURE,
      payload: err
    }
  }
}

export const loadTrainingType = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/trainingtypes`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadTrainingType_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadTrainingType_failure(err)))

  function loadTrainingType_success(data) {
    return {
      type: lookupsConstant.GET_TRAININGTYPE_SUCCESS,
      payload: data
    }
  }

  function loadTrainingType_failure(err) {
    return {
      type: lookupsConstant.GET_TRAININGTYPE_FAILURE,
      payload: err
    }
  }
}

export const loadTrainingLevel = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/traininglevels`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadTrainingLevel_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadTrainingLevel_failure(err)))

  function loadTrainingLevel_success(data) {
    return {
      type: lookupsConstant.GET_TRAININGLEVEL_SUCCESS,
      payload: data
    }
  }

  function loadTrainingLevel_failure(err) {
    return {
      type: lookupsConstant.GET_TRAININGLEVEL_FAILURE,
      payload: err
    }
  }
}

export const loadTrainingStatus = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/trainingstatus`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadTrainingStatus_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadTrainingStatus_failure(err)))

  function loadTrainingStatus_success(data) {
    return {
      type: lookupsConstant.GET_TRAININGSTATUS_SUCCESS,
      payload: data
    }
  }

  function loadTrainingStatus_failure(err) {
    return {
      type: lookupsConstant.GET_TRAININGSTATUS_FAILURE,
      payload: err
    }
  }
}


export const loadEmpTrainingStatus = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/emptrainingstatus`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(loadTrainingStatus_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(loadTrainingStatus_failure(err)))

  function loadTrainingStatus_success(data) {
    return {
      type: lookupsConstant.GET_EMP_TRAINING_STATUS_SUCCESS,
      payload: data
    }
  }

  function loadTrainingStatus_failure(err) {
    return {
      type: lookupsConstant.GET_EMP_TRAINING_STATUS_FAILURE,
      payload: err
    }
  }
}


export const loadEmployeeLevel = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/employeelevels`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(load_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(load_failure(err)))

  function load_success(data) {
    return {
      type: lookupsConstant.GET_EMPLOYEELEVEL_SUCCESS,
      payload: data
    }
  }

  function load_failure(err) {
    return {
      type: lookupsConstant.GET_EMPLOYEELEVEL_FAILURE,
      payload: err
    }
  }
}

export const loadYesNo = () => (dispatch) => {
  axiosFetch({
    method: "get",
    url: `/Lookup/yesno`
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(load_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(load_failure(err)))

  function load_success(data) {
    return {
      type: lookupsConstant.GET_YESNO_SUCCESS,
      payload: data
    }
  }

  function load_failure(err) {
    return {
      type: lookupsConstant.GET_YESNO_FAILURE,
      payload: err
    }
  }
}

export const loadRepotingUsers = (id,boolValue) => (dispatch) => {
  axiosFetch({
    method: "post",
    url: `/Lookup/reportingusers/${id}`,
    requestConfig: {
      "includeReporting": boolValue
  }
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(load_success(res.data));
      }
      // if (res.status === 400) {
      //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      // }
      else if (res.status === 401) {
        window.location.href = "/";
      }
    })

    .catch(err => dispatch(load_failure(err)))

  function load_success(data) {
    return {
      type: lookupsConstant.GET_ONLY_REPORTING_USERS_SUCCESS,
      payload: data
    }
  }

  function load_failure(err) {
    return {
      type: lookupsConstant.GET_ONLY_REPORTING_USERS_FAILURE,
      payload: err
    }
  }
}